import {CSSProperties} from 'react'
import _ from 'lodash'

export interface ISVGPieDataItem {
  value: number
  color?: CSSProperties['backgroundColor']
}

export interface ISVGPieProps {
  data: ISVGPieDataItem[]
  total?: number
  radius?: number
}

export function SVGPie(props: ISVGPieProps) {
  const {data, total, radius} = {
    radius: 50,
    ...props,
  }
  const r2 = radius * 2
  const rh = radius / 2
  const c = radius * Math.PI
  const sum = total ? total : _.chain(data).map('value').sum().value()
  if (sum === 0) return null
  let acc = 0
  const slices = _.chain([
    ...data,
    total ?
      {
        value: total,
        color: 'var(--bg-color)',
      }
    : undefined,
  ])
    .compact()
    .map((v, i) => {
      const {value, color} = v
      const p = value / sum // slice percent value
      const o = acc * c // accumulated offset earlier slices
      const s = `0 ${o} ${p * c} ${c}` // stroke dash array
      acc += p
      return (
        <circle
          key={i}
          r={rh}
          cx={radius}
          cy={radius}
          fill='transparent'
          stroke={color || 'var(--text-color)'}
          strokeWidth={radius}
          strokeDasharray={s}
          transform={`rotate(-90) translate(-${r2})`}
        />
      )
    })
    .value()
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      width={r2}
      height={r2}
      viewBox={`0 0 ${r2} ${r2}`}
    >
      {/* <circle
                r={radius}
                cx={radius}
                cy={radius}
                fill="black"
            /> */}
      {slices}
      <circle
        r={radius - 1}
        cx={radius}
        cy={radius}
        stroke='var(--border-color)'
        strokeWidth={2}
        fill='transparent'
        opacity={0.7}
      />
    </svg>
  )
}
